/* unplugin-vue-components disabled */import { render } from "./HeaderForPC.vue?vue&type=template&id=25572847&scoped=true"
import script from "./HeaderForPC.vue?vue&type=script&lang=js"
export * from "./HeaderForPC.vue?vue&type=script&lang=js"

import "./HeaderForPC.vue?vue&type=style&index=0&id=25572847&scoped=true&lang=less"

import exportComponent from "/root/workspace/coottlVideoPage_JjFl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25572847"]])

export default __exports__